var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"type":"warning"}},[_vm._v(" "+_vm._s(_vm.$lang('main.works.not_available'))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }